import { motion } from "motion/react"
import { FormattedMessage } from "react-intl";
import MobileAndroid from "../../components/ImageMobileAndroid";
import DesktopWin from "../../components/ImageDesktopWin";
import { AD_CLIENT, AD_SLOT } from "../privacy/constants";

export default function PageOne({jump}) {
    return (
        <motion.div
        className="mainScrollBaseContainer"
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.5 }}
        >
            <div className="centered main">
                <div className="horizontal">
                    <MobileAndroid/>
                    <div className="featureCard flexible">
                        <h2><FormattedMessage id="main.shortDesc"/></h2>
                        <FormattedMessage id="main.longDesc"/>
                        <ul className="mainList">
                            <li><FormattedMessage id="keyPoint.1"/></li>
                            <li><FormattedMessage id="keyPoint.2"/></li>
                            <li><FormattedMessage id="keyPoint.3"/></li>
                            <li><FormattedMessage id="keyPoint.4"/></li>
                            <li><FormattedMessage id="keyPoint.5"/></li>
                            <li><FormattedMessage id="keyPoint.6"/></li>
                            <li><FormattedMessage id="keyPoint.7"/></li>
                            <li><FormattedMessage id="keyPoint.8"/></li>
                        </ul>
                        <br/>
                        <p className="onlyDesktop">
                            <h2><FormattedMessage id="downloadNow"/></h2>
                            <div className="onlyDesktop">
                                <QRCodes/>
                            </div>
                            <span className="centered"><button className="contactBtn" onClick={() => jump(7)} ><FormattedMessage id="toDownload"/></button></span>
                        </p>

                    </div>
                    <div className="noSpace">
                        <DesktopWin/>
                        <amp-ad width="100%" height="100%"
                            type="adsense"
                            data-ad-client={AD_CLIENT}
                            data-ad-slot={AD_SLOT}
                            data-auto-format="rspv"
                            data-full-width=""
                        >
                            <div overflow=""></div>
                        </amp-ad>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}
function QRCodes () {
    return(<div className="centered">
        
    </div>
    )
}